import React, { Component } from "react";
export default class SentenceCompletion extends Component {
  render() {
    var {
      sentence_completion_q1_s1,
      sentence_completion_q1_s2,
      sentence_completion_q2_s1,
      sentence_completion_q2_s2,
      sentence_completion_c1,
      sentence_completion_c2,
      sentence_completion_q2_s3,
      sentence_completion_c3,
      sentence_completion_q2_s4,
      sentence_completion_c4,
      sentence_completion_q2_s5,
      sentence_completion_c5,
      sentence_completion_q2_s6,
      sentence_completion_c6,
      sentence_completion_score,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-12">
          <ul
            style={{
              paddingLeft: 20,
              fontSize: 19,
              paddingTop: 20,
            }}
          >
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Complete the sentences to make sense, give 2 examples, then
                  switch to scored questions where participants complete
                  sentences with words that do not make sense.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Scoring:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Give 2 points for completely unconnected word, 1 for related
                  word (e.g. associated or opposite meaning) and 0 for exact
                  word. See table below for scoring examples and to populate
                  score/answers.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Note: sentences can be ungrammatical.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  “Listen carefully to these sentences and as soon as I have
                  finished reading them, please tell me a word that finishes the
                  sentence as quickly as possible.” For example, ‘She was so
                  tired that she went straight to…bed”.
                  <ul style={{ paddingLeft: 40 }}>
                    <li style={{ listStyle: "circle" }}>
                      Let's try 2 examples
                    </li>
                    <li style={{ listStyle: "circle" }}>
                      If person answers with a word which completes the sentence
                      in context then remind them that the requirement is to
                      provide an answer that bears no significance to the
                      context of the sentence.
                    </li>
                    <li style={{ listStyle: "circle" }}>
                      Progress through all questions, even when incorrect
                      answers are provided.
                    </li>
                    <li style={{ listStyle: "circle" }}>
                      If the person does not respond within 20 seconds, move
                      onto the next question.
                    </li>
                    <li style={{ listStyle: "circle" }}>
                      Take the first answer generated by the participant, do not
                      allow self-correction.
                    </li>
                  </ul>
                </li>
              </ul>
              <div className="row mt-3">
                <div className="col-lg-6">
                  <p className="ml-3">
                    1. He called the restaurant to reserve a
                  </p>
                  <input
                    disabled
                    type="text"
                    name="sentence_completion_q1_s1"
                    value={sentence_completion_q1_s1}
                    className="ecas-input-field col-lg-10 ml-3 sentence-completion-input"
                  />
                </div>
                <div className="col-lg-6">
                  <p className="ml-3">
                    2. When she got up in the morning, the sun was
                  </p>
                  <input
                    disabled
                    type="text"
                    name="sentence_completion_q1_s2"
                    value={sentence_completion_q1_s2}
                    className="ecas-input-field col-lg-10 ml-3 sentence-completion-input"
                  />
                </div>
              </div>
            </li>
            <li style={{ listStyle: "square" }}>
              Say: “ I’d like you to do that again, but this time the word you
              give should not make sense whatsoever in the context of the
              sentence. It must not be related to the word that actually
              completes the sentence. For example, ‘John cut his hand with the
              sharp…orange’.
              <ul style={{ paddingLeft: 30 }}>
                <li style={{ listStyle: "circle" }}>Let's try 2 examples</li>
                <li style={{ listStyle: "circle" }}>
                  If person answers with a word which completes the sentence in
                  context then remind them that the requirement is to provide an
                  answer that bears no significance to the context of the
                  sentence.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Progress through all questions, even when incorrect answers
                  are provided.
                </li>
                <li style={{ listStyle: "circle" }}>
                  If the person does not respond within 20 seconds, move onto
                  the next question. Take the first answer generated by the
                  participant, do not allow self-correction.
                </li>
              </ul>
            </li>
          </ul>
          <div className="row mt-3">
            <div className="col-lg-6">
              <p className="ml-3 fs-19">
                1. He called the restaurant to reserve a
              </p>
              <input
                disabled
                type="text"
                name="sentence_completion_q1_s1"
                value={sentence_completion_q1_s1}
                className="ecas-input-field col-lg-10 ml-3 sentence-completion-input"
              />
            </div>
            <div className="col-lg-6">
              <p className="ml-3 fs-19">
                2. When she got up in the morning, the sun was
              </p>
              <input
                disabled
                type="text"
                name="sentence_completion_q1_s2"
                value={sentence_completion_q1_s2}
                className="ecas-input-field col-lg-10 ml-3 sentence-completion-input"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <table
                cellSpacing={5}
                style={{ width: "95%", marginLeft: 17 }}
                border={1}
                cellPadding={6}
                className="answer-table table table-responsive"
              >
                <tr>
                  <th style={{ width: 40 }}></th>
                  <th>Question</th>
                  <th>Answer</th>
                  <th style={{ width: 120 }} className="text-align-center">
                    2 Points <br />
                    <span
                      style={{
                        fontWeight: 400,
                        fontSize: 13,
                      }}
                    >
                      (Unconnected Word)
                    </span>
                  </th>
                  <th style={{ width: 120 }} className="text-align-center">
                    1 Point <br />
                    <span
                      style={{
                        fontWeight: 400,
                        fontSize: 13,
                      }}
                    >
                      (Related word)
                    </span>
                  </th>
                  <th style={{ width: 120 }} className="text-align-center">
                    0 Point <br />
                    <span
                      style={{
                        fontWeight: 400,
                        fontSize: 13,
                      }}
                    >
                      (Exact Word)
                    </span>
                  </th>
                </tr>
                <tr>
                  <td>1</td>
                  <td>The mailman knocked on the</td>
                  <td>
                    <input
                      type="text"
                      name="sentence_completion_q2_s1"
                      value={sentence_completion_q2_s1}
                      style={{
                        margin: "10px auto 10px auto",
                        display: "flex",
                      }}
                      className="ecas-input-field col-lg-10 sentence-completion-input"
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c1"
                      value={2}
                      checked={sentence_completion_c1 == "2" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c1"
                      value={1}
                      checked={sentence_completion_c1 == "1" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c1"
                      value={0}
                      checked={sentence_completion_c1 == "0" ? true : false}
                    />
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>He brought his umbrella with him in case of</td>
                  <td>
                    <input
                      type="text"
                      name="sentence_completion_q2_s2"
                      value={sentence_completion_q2_s2}
                      style={{
                        margin: "10px auto 10px auto",
                        display: "flex",
                      }}
                      className="ecas-input-field col-lg-10 sentence-completion-input"
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c2"
                      value={2}
                      checked={sentence_completion_c2 == "2" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c2"
                      value={1}
                      checked={sentence_completion_c2 == "1" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c2"
                      value={0}
                      checked={sentence_completion_c2 == "0" ? true : false}
                    />
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Sally spread her toast with butter and</td>
                  <td>
                    <input
                      type="text"
                      name="sentence_completion_q2_s3"
                      value={sentence_completion_q2_s3}
                      style={{
                        margin: "10px auto 10px auto",
                        display: "flex",
                      }}
                      className="ecas-input-field col-lg-10 sentence-completion-input"
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c3"
                      value={2}
                      checked={sentence_completion_c3 == "2" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c3"
                      value={1}
                      checked={sentence_completion_c3 == "1" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c3"
                      value={0}
                      checked={sentence_completion_c3 == "0" ? true : false}
                    />
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>John went to the barbers to get his hair</td>
                  <td>
                    <input
                      type="text"
                      name="sentence_completion_q2_s4"
                      value={sentence_completion_q2_s4}
                      style={{
                        margin: "10px auto 10px auto",
                        display: "flex",
                      }}
                      className="ecas-input-field col-lg-10 sentence-completion-input"
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c4"
                      value={2}
                      checked={sentence_completion_c4 == "2" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c4"
                      value={1}
                      checked={sentence_completion_c4 == "1" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c4"
                      value={0}
                      checked={sentence_completion_c4 == "0" ? true : false}
                    />
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>She dived into the swimming</td>
                  <td>
                    <input
                      type="text"
                      name="sentence_completion_q2_s5"
                      value={sentence_completion_q2_s5}
                      style={{
                        margin: "10px auto 10px auto",
                        display: "flex",
                      }}
                      className="ecas-input-field col-lg-10 sentence-completion-input"
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c5"
                      value={2}
                      checked={sentence_completion_c5 == "2" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c5"
                      value={1}
                      checked={sentence_completion_c5 == "1" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c5"
                      value={0}
                      checked={sentence_completion_c5 == "0" ? true : false}
                    />
                  </td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>They all went to the local café for something to</td>
                  <td>
                    <input
                      type="text"
                      name="sentence_completion_q2_s6"
                      value={sentence_completion_q2_s6}
                      style={{
                        margin: "10px auto 10px auto",
                        display: "flex",
                      }}
                      className="ecas-input-field col-lg-10 sentence-completion-input"
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c6"
                      value={2}
                      checked={sentence_completion_c6 == "2" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c6"
                      value={1}
                      checked={sentence_completion_c6 == "1" ? true : false}
                    />
                  </td>
                  <td>
                    <input
                      className="position-relative sent_com_input_c"
                      type="checkbox"
                      name="sentence_completion_c6"
                      value={0}
                      checked={sentence_completion_c6 == "0" ? true : false}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <hr />
          <div className="col-lg-6">
            <br />
            <span className="fs-19">Score </span>
            <input
              type="number"
              disabled
              name="sentence_completion_score"
              value={sentence_completion_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
